import DeviceType from '@/shared/utils/DeviceType';

const getGameProvidersVariables = (site: Site) => ({
  filter: { site, currency: 'USDT', section: 1 },
  menuItemsFilter: { type: DeviceType.DESKTOP },
});

export default getGameProvidersVariables;
